import styled from "styled-components";

const TopBarLogo = styled.img`
  height: 32px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export default TopBarLogo;
